import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { ErrorBoundary } from '@/components/feedback/error-boundary'
import { AppShell } from '@/components/layout/app-shell'
import { useAuthStore } from '@/stores/auth-store'

export const Route = createFileRoute('/_app')({
  beforeLoad: () => {
    if (useAuthStore.getState().token === null) {
      throw redirect({ to: '/login' })
    }
  },
  component: AppLayout,
})

function AppLayout() {
  return (
    <AppShell>
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
    </AppShell>
  )
}
